import * as Yup from 'yup'

const FormValidates = () => {

  return Yup.object().shape({
    password: Yup.string().required(),
  })
}
export default FormValidates